import { render, staticRenderFns } from "./GStudentAllCompetencyDistribution.vue?vue&type=template&id=26b26caf&"
import script from "./GStudentAllCompetencyDistribution.vue?vue&type=script&lang=ts&"
export * from "./GStudentAllCompetencyDistribution.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentAllCompetencyDistribution.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports